import { useState } from "react";
import { Play, CalendarClock } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { useLeadModals } from "@/components/LeadModals";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const TYPES = ["All", "360° Room Tours", "Drone Flights", "Promo Clips"];

const VIDEOS = [
  {
    type: "360° Room Tours",
    title: "Modern Hillside Estate Walkthrough",
    duration: "0:58",
    video: "https://upload.wikimedia.org/wikipedia/commons/transcoded/e/ea/Paris_luxury_apartments_-_4_rue_Lincoln%2C_2022.webm/Paris_luxury_apartments_-_4_rue_Lincoln%2C_2022.webm.480p.vp9.webm",
    img: "https://images.unsplash.com/photo-1628744448839-a475cc0e90c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwcHJvcGVydHklMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "Drone Flights",
    title: "Aerial View: 4BR Family Home",
    duration: "0:30",
    video: "https://upload.wikimedia.org/wikipedia/commons/transcoded/1/1e/Addison%2C_VT_Home_%28aerial_drone_footage%29.webm/Addison%2C_VT_Home_%28aerial_drone_footage%29.webm.480p.vp9.webm",
    img: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwcHJvcGVydHklMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "360° Room Tours",
    title: "Downtown Penthouse Tour",
    duration: "0:45",
    img: "https://images.unsplash.com/photo-1717167398817-121e3c283dbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwcHJvcGVydHklMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "Promo Clips",
    title: "Why Clients Choose Sarah",
    duration: "0:40",
    img: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjb25maWRlbnQlMjByZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "Promo Clips",
    title: "Meet Your Local Expert",
    duration: "0:35",
    img: "https://images.unsplash.com/photo-1718209881007-c0ecdfc00f9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjb25maWRlbnQlMjByZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "Drone Flights",
    title: "East Austin From Above",
    duration: "0:55",
    video: "https://upload.wikimedia.org/wikipedia/commons/transcoded/a/ac/Aerial_views_of_Newport_Rhode_Island_historic_district%2C_old_town%2C_Trinity_Church%2C_Hunter_House%2C_and_Vernon_House%2C_USA.webm/Aerial_views_of_Newport_Rhode_Island_historic_district%2C_old_town%2C_Trinity_Church%2C_Hunter_House%2C_and_Vernon_House%2C_USA.webm.480p.vp9.webm",
    img: "https://images.unsplash.com/photo-1770199105692-9e52ff137cad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjb25maWRlbnQlMjByZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "Promo Clips",
    title: "Just Listed: June Highlights",
    duration: "0:50",
    video: "https://upload.wikimedia.org/wikipedia/commons/transcoded/3/3d/Central_Newport_Beach_Harbor_by_Don_Ramey_Logan_with_Chopin_Fantaisie-Impromptu_in_C-sharp.webm/Central_Newport_Beach_Harbor_by_Don_Ramey_Logan_with_Chopin_Fantaisie-Impromptu_in_C-sharp.webm.480p.vp9.webm",
    img: "https://images.unsplash.com/photo-1628744448839-a475cc0e90c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwcHJvcGVydHklMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
  {
    type: "360° Room Tours",
    title: "London Commuter Town Gem",
    duration: "0:48",
    img: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwcHJvcGVydHklMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3ODY4MzY0MDJ8MA&ixlib=rb-4.1.0&q=80&w=900",
  },
];

export default function GalleryPage() {
  const [filter, setFilter] = useState("All");
  const [active, setActive] = useState(null);
  const { openDemo } = useLeadModals();
  const visible = filter === "All" ? VIDEOS : VIDEOS.filter((v) => v.type === filter);

  return (
    <main className="bg-hero-cream pt-[72px]" data-testid="gallery-page">
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
        <Reveal>
          <span className="inline-block border-2 border-hero-black px-3 py-1 font-display text-sm font-semibold uppercase tracking-[0.3em] text-hero-black">
            07 — Samples
          </span>
          <h1 className="mt-6 font-display text-4xl font-bold uppercase tracking-tight text-hero-black sm:text-5xl lg:text-6xl">
            Sample Gallery
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-hero-black/70 sm:text-lg">
            360° room tours, drone flights, and promo clips — a taste of every format we produce.
            These are representative samples; your content is custom-made for your company.
            Full-length samples are shared on the demo call.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap gap-3" role="tablist" aria-label="Filter videos by type">
            {TYPES.map((t) => (
              <button
                key={t}
                onClick={() => setFilter(t)}
                data-testid={`gallery-filter-${t.toLowerCase().replace(/\s+/g, "-")}`}
                className={`rounded-md border-2 px-4 py-2 font-display text-sm font-semibold uppercase tracking-wide transition-all duration-300 ${
                  filter === t
                    ? "border-hero-black bg-hero-gold text-hero-black shadow-[3px_3px_0_#111111]"
                    : "border-hero-black/15 bg-white text-hero-black/70 hover:border-hero-black hover:text-hero-black"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </Reveal>

        <motion.div layout className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence mode="popLayout">
            {visible.map((v, i) => (
              <motion.article
                layout
                key={v.title}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.45, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                onClick={() => setActive(v)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && setActive(v)}
                className="group cursor-pointer overflow-hidden rounded-md border-2 border-hero-black/10 bg-white shadow-md transition-shadow duration-300 hover:shadow-xl"
                data-testid={`gallery-card-${i + 1}`}
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={v.img}
                    alt={`${v.type} sample: ${v.title}`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-hero-black/0 transition-colors duration-300 group-hover:bg-hero-black/40" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="rounded-full bg-hero-gold p-4 text-hero-black shadow-xl transition-transform duration-300 group-hover:scale-110">
                      <Play className="h-6 w-6 fill-hero-black" aria-hidden="true" />
                    </span>
                  </div>
                  <span className="absolute left-3 top-3 rounded-sm bg-hero-gold px-2 py-1 font-display text-xs font-semibold uppercase tracking-wide text-hero-black">
                    {v.type}
                  </span>
                  <span className="absolute bottom-3 right-3 rounded-sm bg-hero-black px-2 py-1 text-xs font-semibold text-white">
                    {v.duration}
                  </span>
                </div>
                <div className="p-5">
                  <h2 className="font-display text-lg font-bold uppercase tracking-wide text-hero-black">{v.title}</h2>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>

        <Reveal className="mt-16 text-center">
          <p className="text-base text-hero-black/70">Want to see full-length samples matched to your market?</p>
          <button
            onClick={openDemo}
            data-testid="gallery-cta-demo"
            className="mt-5 rounded-md bg-hero-gold px-8 py-4 font-display text-lg font-semibold uppercase tracking-wide text-hero-black shadow-[5px_5px_0_#111111] transition-all duration-300 hover:-translate-y-1 hover:shadow-[8px_8px_0_#111111]"
          >
            Book 15-Min Demo
          </button>
        </Reveal>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl overflow-hidden border-2 border-hero-black bg-white p-0" data-testid="video-modal">
          {active && active.video && (
            <>
              <video
                key={active.video}
                src={active.video}
                poster={active.img}
                controls
                autoPlay
                playsInline
                className="aspect-video w-full bg-hero-black"
                data-testid="gallery-video-player"
              />
              <div className="flex items-center justify-between gap-4 p-5">
                <div>
                  <h2 className="font-display text-xl font-bold uppercase tracking-wide text-hero-black">{active.title}</h2>
                  <p className="mt-1 text-sm font-semibold text-hero-black/60">{active.type} · Sample clip</p>
                </div>
                <span className="rounded-sm bg-hero-gold px-3 py-1 font-display text-sm font-semibold uppercase text-hero-black">
                  {active.duration}
                </span>
              </div>
            </>
          )}
          {active && !active.video && (
            <div className="p-8 text-center sm:p-10">
              <span className="inline-flex rounded-md bg-hero-blue p-3 text-white">
                <CalendarClock className="h-7 w-7" aria-hidden="true" />
              </span>
              <h2 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight text-hero-black">
                {active.title}
              </h2>
              <p className="mx-auto mt-3 max-w-md text-base leading-relaxed text-hero-black/70">
                The full {active.type.toLowerCase()} sample is shared on the demo call — custom-made examples
                for your market and brand.
              </p>
              <button
                onClick={() => { setActive(null); openDemo(); }}
                data-testid="video-modal-demo-cta"
                className="mt-7 rounded-md bg-hero-gold px-8 py-3.5 font-display text-base font-semibold uppercase tracking-wide text-hero-black shadow-[4px_4px_0_#111111] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_#111111]"
              >
                Book 15-Min Demo
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </main>
  );
}
